<template>
  <teleport to="body">
    <div :class="['gfr-dropdown-wrapper', wrapperClass]" :style="rect && contentStyle" @click.stop="triggerClose">
      <transition
        enter-active-class="transition duration-300 ease-out"
        enter-from-class="transform scale-90 opacity-0"
        enter-to-class="transform scale-100 opacity-100"
        leave-active-class="transition duration-200 ease-out"
        leave-from-class="transform scale-100 opacity-100"
        leave-to-class="transform scale-90 opacity-0"
        @before-enter="onOpen"
      >
        <div v-show="open" ref="ctx" :class="['gfr-dropdown-content', props.class]">
          <slot />
        </div>
      </transition>
    </div>
  </teleport>
</template>
<script lang="ts" setup>
import { PropType } from 'vue'
import { UnknownProp } from '~/components/gfr/utils/base'
type placementOptions = 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end'
const open = inject('open') as Ref<boolean>
const rect: any = inject('rect')
const triggerClose = inject('triggerClose') as () => void
const props = defineProps({
  class: UnknownProp,
  wrapperClass: UnknownProp,
  offsetX: { type: Number, default: 0 },
  offsetY: { type: Number, default: 12 },
  placement: { type: String as PropType<placementOptions>, default: 'bottom-start' }
})
const emit = defineEmits(['open'])
const ctx = ref<HTMLElement>()
const ctxRect = ref<{ width: number; height: number } | null>(null)
const contentStyle = computed(() => {
  if (!rect.value || !ctxRect.value) return ''
  const { height, top, left, right } = rect.value
  const { width: ctxWidth, height: ctxHeight } = ctxRect.value || { width: 0, height: 0 }
  const [startX, endX, topY, bottomY] = [
    left + props.offsetX,
    right - props.offsetX - ctxWidth,
    top - props.offsetY - ctxHeight,
    top + height + props.offsetY
  ]
  const variable = {
    '--dropdown-transform-x': '0px',
    '--dropdown-transform-y': '0px'
  }
  switch (props.placement) {
    case 'bottom-start':
      startX + ctxWidth <= window.innerWidth
        ? (variable['--dropdown-transform-x'] = `${startX}px`)
        : (variable['--dropdown-transform-x'] = `${endX}px`)
      variable['--dropdown-transform-y'] = `${bottomY}px`
      break
    case 'top-start':
      startX + ctxWidth <= window.innerWidth
        ? (variable['--dropdown-transform-x'] = `${startX}px`)
        : (variable['--dropdown-transform-x'] = `${endX}px`)
      variable['--dropdown-transform-y'] = `${topY}px`
      break
    case 'top-end':
      endX + ctxWidth <= window.innerWidth
        ? (variable['--dropdown-transform-x'] = `${endX}px`)
        : (variable['--dropdown-transform-x'] = `${startX}px`)
      variable['--dropdown-transform-y'] = `${topY}px`
      break
    case 'bottom-end':
    default:
      endX + ctxWidth <= window.innerWidth
        ? (variable['--dropdown-transform-x'] = `${endX}px`)
        : (variable['--dropdown-transform-x'] = `${startX}px`)
      variable['--dropdown-transform-y'] = `${bottomY}px`
      break
  }
  return variable
})
const onOpen = () => {
  emit('open')
}
async function getCtxRect() {
  await nextTick()
  return {
    width: ctx.value?.offsetWidth || 0,
    height: ctx.value?.offsetHeight || 0
  }
}
watch(
  () => open.value,
  async (val) => {
    if (val) {
      !ctxRect.value && (ctxRect.value = await getCtxRect())
    }
  }
)
</script>
